import BoardsApi from './boardsApi'
import { DOMAIN_NAME, PREFIX } from './Constants'

/**
 * Rest-API for React-front
 */

const getDate = () => {
 // return new Date(new Date() - new Date(store.appStore.timeDifference))
}
const CALC_TIME = false

export function ownGetTime() {
  //synchronize time with server

  let fetchParams = {
    mode: 'cors',
    method: 'GET',
    headers: {
      'Accept': 'application/vnd.uberblik.time+json;'
      //  'access-token': token,
      // 'Authorization': 'URS-HMAC-256, Credential=' + credential + ', SignedHeaders=accept;access-token;x-uberblik-timestamp, Signature=' + signature,
      //'x-uberblik-timestamp': dateTime
    }
  }
  //console.log(DOMAIN_NAME, PREFIX)
  //console.log(DOMAIN_NAME + PREFIX)
  return fetch(DOMAIN_NAME + PREFIX + '/ping/time', fetchParams).then(function (response) {
    return response
  })
}

function buildParams(params) {
  const queryParamsList = []
  for (const key in params) {
    if (params.hasOwnProperty(key)) {
      queryParamsList.push([key, params[key]])
    }
  }
  return queryParamsList
    .sort((a, b) => a[0].localeCompare(b[0]))
    .reduce((acc, pair) => acc + `${pair[0]}=${pair[1]}&`, '?')
    .slice(0, -1)
}

/**
 * Represents universal request (not for uploading)
 * @param {string} method
 * @param {string} path
 * @param {string} acceptType
 * @param {object} params
 * @param {object|string} body
 */
export function ownRequest(method, path, acceptType = '*/*', params = {}, body = '', signal = null) {
  let token = localStorage.getItem('token')
  let secret = localStorage.getItem('secret')
  let dateTime = CALC_TIME ? getDate() : new Date()

  const queryParams = buildParams(params)
  dateTime = dateTime.toISOString()
  let finalPath = path
  if (queryParams !== '') {
    finalPath += queryParams
  }
  // dateTime = '2017-08-15T04:57:21.632Z'
  let date = dateTime.slice(0, 10).replace(/-/g, '')
  let credential = BoardsApi.getCredential(token, date)
  let signature, fetchParams = {}
  if (signal !== null) {
    fetchParams.signal = signal
  }
  switch (method) {
    case 'POST':
    case 'PUT':
    case 'PATCH':
      if (body !== '') {
        fetchParams.body = BoardsApi.prepareBody(body)
        signature = BoardsApi.getSignature(method, DOMAIN_NAME + PREFIX + finalPath, dateTime, token, secret, acceptType, body)
      } else {
        signature = BoardsApi.getSignature(method, DOMAIN_NAME + PREFIX + finalPath, dateTime, token, secret, acceptType)
      }
      break
    default:
      signature = BoardsApi.getSignature(method, DOMAIN_NAME + PREFIX + finalPath, dateTime, token, secret, acceptType)
      break
  }
  fetchParams = Object.assign({
    mode: 'cors',
    method,
    cache: 'default',
    headers: {
      'Accept': acceptType,
      'access-token': token,
      'Authorization': 'URS-HMAC-256, Credential=' + credential + ', SignedHeaders=accept;access-token;x-uberblik-timestamp, Signature=' + signature,
      'x-uberblik-timestamp': dateTime
    }
  }, fetchParams)
  return fetch(DOMAIN_NAME + PREFIX + finalPath, fetchParams)
}

/**
 * The request for signing up (aka self-invitation).
 * Uses invite token instead of accept token, and also replace header with 'invitation-token'
 */
export function ownRequestPostInvitation(path, token, acceptType, body) {
  let secret = localStorage.getItem('secret')
  let dateTime = CALC_TIME ? getDate() : new Date()
  dateTime = dateTime.toISOString()
  // dateTime = '2017-08-15T04:57:21.632Z'
  let date = dateTime.slice(0, 10).replace(/-/g, '')
  let accept = acceptType ? acceptType : '*/*'
  let credential = BoardsApi.getCredentialForInvite(token, date)
  let signature = BoardsApi.getSignature('POST', DOMAIN_NAME + PREFIX + path, dateTime, token, secret, accept, body, true)
  return fetch(DOMAIN_NAME + PREFIX +  path, {
    mode: 'cors',
    method: 'POST',
    headers: {
      'Accept': accept,
      'invitation-token': token,
      'Authorization': 'URS-HMAC-256, Credential=' + credential + ', SignedHeaders=accept;invitation-token;x-uberblik-timestamp, Signature=' + signature,
      'x-uberblik-timestamp': dateTime
    },
    body: JSON.stringify(body)
  }).then(function (response) {
    return response
  })
}

/**
 * The request for accepting invite.
 * Adds 'invitation-token' header
 */
export function ownRequestPatchInvite(path, acceptType, inviteToken, data) {
  let token = localStorage.getItem('token')
  let secret = localStorage.getItem('secret')
  let dateTime = CALC_TIME ? getDate() : new Date()
  dateTime = dateTime.toISOString()
  // dateTime = '2017-08-15T04:57:21.632Z'
  let date = dateTime.slice(0, 10).replace(/-/g, '')
  let credential = BoardsApi.getCredential(token, date)
  let signature = BoardsApi.getSignature('PATCH', DOMAIN_NAME + PREFIX + path, dateTime, token, secret, acceptType, data)
  return fetch(DOMAIN_NAME + PREFIX + path, {
    mode: 'cors',
    method: 'PATCH',
    headers: {
      'Accept': acceptType,
      'access-token': token,
      'invitation-token': inviteToken,
      'Authorization': 'URS-HMAC-256, Credential=' + credential + ', SignedHeaders=accept;access-token;x-uberblik-timestamp, Signature=' + signature,
      'x-uberblik-timestamp': dateTime
    },
    body: JSON.stringify(data)
  }).then(function (response) {
    return response
  })
}

/**
 * The request for getting invite by token and path.
 * Uses invite token instead of accept token, and also replace header with 'invitation-token'
 */
export function ownRequestGetInvitation(path, token, contentType) {
  let secret = localStorage.getItem('secret')
  let dateTime = CALC_TIME ? getDate() : new Date()
  dateTime = dateTime.toISOString()
  // dateTime = '2017-08-15T04:57:21.632Z'
  let date = dateTime.slice(0, 10).replace(/-/g, '')
  let credential = BoardsApi.getCredentialForInvite(date)
  let signature = BoardsApi.getSignature('GET', DOMAIN_NAME + PREFIX + path, dateTime, token, secret, '*/*', null, true)
  return fetch(DOMAIN_NAME + PREFIX + path, {
    mode: 'cors',
    method: 'GET',
    contentType: contentType,
    headers: {
      'Accept': '*/*',
      'invitation-token': token,
      'Authorization': 'URS-HMAC-256, Credential=' + credential + ', SignedHeaders=accept;invitation-token;x-uberblik-timestamp, Signature=' + signature,
      'x-uberblik-timestamp': dateTime
    }
  }).then(function (response) {
    return response
  })
}

/**
 * The request for file uploading.
 * Uses FormData
 */
export function ownRequestUploadFile(method = 'POST', path, file, accept = '*/*') {
  let token = localStorage.getItem('token')
  let secret = localStorage.getItem('secret')
  let dateTime = CALC_TIME ? getDate() : new Date()
  dateTime = dateTime.toISOString()
  // dateTime = '2017-08-15T04:57:21.632Z'
  let date = dateTime.slice(0, 10).replace(/-/g, '')
  let credential = BoardsApi.getCredential(token, date)

  let formData = new FormData()
  formData.append('file', file)

  let signature = BoardsApi.getSignature('POST', DOMAIN_NAME + PREFIX + path, dateTime, null, secret, null, '')
  let auth = 'URS-HMAC-256, Credential=' + credential + ', SignedHeaders=x-uberblik-timestamp, Signature=' + signature

  return fetch(DOMAIN_NAME + PREFIX + path, {
    mode: 'cors',
    method,
    headers: {
      'Accept': accept,
      'access-token': token,
      'Authorization': auth,
      'x-uberblik-timestamp': dateTime
    },
    body: formData
  }).then(function (response) {
    return response
  })
}

/**
 * The request for file uploading.
 * Uses FormData
 */
export function ownRequestUploadLink(path, link) {
  let token = localStorage.getItem('token')
  let secret = localStorage.getItem('secret')
  let dateTime = CALC_TIME ? getDate() : new Date()
  dateTime = dateTime.toISOString()
  // dateTime = '2017-08-15T04:57:21.632Z'
  let date = dateTime.slice(0, 10).replace(/-/g, '')
  let accept = 'application/vnd.uberblik.htmlReference+json'
  let credential = BoardsApi.getCredential(token, date)
  let signature = BoardsApi.getSignature('POST', DOMAIN_NAME + PREFIX + path, dateTime, token, secret, accept, link)
  return fetch(DOMAIN_NAME + path, {
    mode: 'cors',
    method: 'POST',
    headers: {
      'Accept': accept,
      'access-token': token,
      'Content-Type': 'application/json;charset=UTF-8',
      'Authorization': 'URS-HMAC-256, Credential=' + credential + ', SignedHeaders=accept;access-token;x-uberblik-timestamp, Signature=' + signature,
      'x-uberblik-timestamp': dateTime
    },
    body: JSON.stringify(link)
  }).then(function (response) {
    return response
  })
}

/**
 * The delete request.
 * Used to delete user and board
 */
export function ownDELETE(file, acceptType, rel) {
  let token = localStorage.getItem('token')
  let secret = localStorage.getItem('secret')
  //console.log(thumbnail)
  let dateTime = CALC_TIME ? getDate() : new Date()
  dateTime = dateTime.toISOString()
  // dateTime = '2017-08-15T04:57:21.632Z'
  let date = dateTime.slice(0, 10).replace(/-/g, '')
  let accept = acceptType ? acceptType : '*/*'

  let link = file._links.filter(function (obj) {
    return obj.rel === rel
  })[0]
  let credential = BoardsApi.getCredential(token, date)
  let signature = BoardsApi.getSignature('DELETE', DOMAIN_NAME + PREFIX + link.href, dateTime, token, secret, accept)
  return fetch(DOMAIN_NAME + PREFIX + link.href, {
    mode: 'cors',
    method: 'DELETE',
    headers: {
      'Accept': accept,
      'access-token': token,
      'Authorization': 'URS-HMAC-256, Credential=' + credential + ', SignedHeaders=accept;access-token;x-uberblik-timestamp, Signature=' + signature,
      'x-uberblik-timestamp': dateTime
    }
  }).then(function (response) {
    return response
  })
}

/**
 * Used to change invitation model of the board, and also user
 */
export function ownPUT(file, acceptType, rel) {
  let token = localStorage.getItem('token')
  let secret = localStorage.getItem('secret')
  //console.log(thumbnail)
  let dateTime = CALC_TIME ? getDate() : new Date()
  dateTime = dateTime.toISOString()
  // dateTime = '2017-08-15T04:57:21.632Z'
  let date = dateTime.slice(0, 10).replace(/-/g, '')
  let accept = acceptType ? acceptType : '*/*'

  let link = file._links.filter(function (obj) {
    return obj.rel === rel
  })[0]
  let credential = BoardsApi.getCredential(token, date)
  let signature = BoardsApi.getSignature('PUT', DOMAIN_NAME + PREFIX + link.href, dateTime, token, secret, accept, file.data)
  return fetch(DOMAIN_NAME + PREFIX + link.href, {
    mode: 'cors',
    method: 'PUT',
    headers: {
      'Accept': accept,
      'access-token': token,
      'Authorization': 'URS-HMAC-256, Credential=' + credential + ', SignedHeaders=accept;access-token;x-uberblik-timestamp, Signature=' + signature,
      'x-uberblik-timestamp': dateTime
    },
    body: JSON.stringify(file.data)
  }).then(function (response) {
    //console.log(response.body)
    return response
  })
}

/**
 * Used to change thumbnail
 */
export function ownUploadFilePUT(data, acceptType, rel, body, params) {
  let token = localStorage.getItem('token')
  let secret = localStorage.getItem('secret')
  let dateTime = CALC_TIME ? getDate() : new Date()
  dateTime = dateTime.toISOString()
  // dateTime = '2017-08-15T04:57:21.632Z'
  let date = dateTime.slice(0, 10).replace(/-/g, '')
  let accept = 'application/json, text/plain, */*'
  let link = data._links.filter(function (obj) {
    return obj.rel === rel
  })[0]
  let credential = BoardsApi.getCredential(token, date)
  let formData = new FormData()
  formData.append('file', body)

  const queryParams = buildParams(params)
  const path = DOMAIN_NAME + PREFIX + link.href + queryParams

  let signature = BoardsApi.getSignature('PUT', path, dateTime, null, secret, null, '')
  let auth = 'URS-HMAC-256, Credential=' + credential + ', SignedHeaders=x-uberblik-timestamp, Signature=' + signature

  return fetch(path, {
    mode: 'cors',
    method: 'PUT',
    headers: {
      'Accept': accept,
      'access-token': token,
      'Authorization': auth,
      'x-uberblik-timestamp': dateTime
    },
    body: formData
  }).then(function (response) {
    return response
  })
}

/**
 * Used to reset password
 */
export function ownResetPassword(file, acceptType, link) {
  let secret = localStorage.getItem('secret')
  let dateTime = CALC_TIME ? getDate() : new Date()
  dateTime = dateTime.toISOString()
  // dateTime = '2017-08-15T04:57:21.632Z'
  let date = dateTime.slice(0, 10).replace(/-/g, '')
  let accept = acceptType ? acceptType : '*/*'
  let credential = BoardsApi.getCredentialForInvite(date)
  let signature = BoardsApi.getSignature('POST', DOMAIN_NAME + PREFIX + link, dateTime, null, secret, accept, file)
  return fetch(DOMAIN_NAME + PREFIX + link, {
    mode: 'cors',
    method: 'POST',
    headers: {
      'Accept': accept,
      'Authorization': 'URS-HMAC-256, Credential=' + credential + ', SignedHeaders=accept;x-uberblik-timestamp, Signature=' + signature,
      'x-uberblik-timestamp': dateTime
    },
    body: file ? JSON.stringify(file) : ''
  }).then(function (response) {
    return response
  })
}

/**
 * Used to change password
 */
export function ownChangePassword(file, acceptType) {
  let body = file.user
  let token = file.token
  let link = file.link
  let secret = localStorage.getItem('secret')
  let dateTime = CALC_TIME ? getDate() : new Date()
  dateTime = dateTime.toISOString()
  let date = dateTime.slice(0, 10).replace(/-/g, '')
  let accept = acceptType ? acceptType : '*/*'
  let credential = BoardsApi.getCredential(date)
  let signature = BoardsApi.getSignature('PATCH', DOMAIN_NAME + PREFIX +  link, dateTime, token, secret, accept, file, false, true)
  return fetch(DOMAIN_NAME + PREFIX + link, {
    mode: 'cors',
    method: 'PATCH',
    headers: {
      'Accept': accept,
      'reset-password-token': token,
      'Authorization': 'URS-HMAC-256, Credential=' + credential + ', SignedHeaders=accept;reset-password-token;x-uberblik-timestamp, Signature=' + signature,
      'x-uberblik-timestamp': dateTime
    },
    body: body ? JSON.stringify(body) : ''
  }).then(function (response) {
    return response
  })
}



// WEBPACK FOOTER //
// ./src/api/ownFetch.js